import React from "react";
import { Link } from "react-router-dom";
import logowhite from "../../../assets/images/logo/logo-white.svg";
import facebook from "../../../assets/images/social2/facebook.svg";
import github from "../../../assets/images/social2/github.svg";
import instagram from "../../../assets/images/social2/instagram.svg";
import twitter from "../../../assets/images/social2/twitter.svg";

export default function FooterHomeThree() {
	return (
		<footer className="fugu--footer-section">
			<div className="container">
				<div className="fugu--footer-top">
					<div className="row">
						<div className="col-lg-3">
							<div className="fugu--textarea">
								<div className="fugu--footer-logo">
									<img src={logowhite} alt="" className="light-version-logo" />
								</div>
								<p>
									Discover NFTs by category, track the latest drops, and follow the collections you
									love to enjoy it!
								</p>
								<div className="fugu--social-icon">
									<ul>
										<li>
											<Link to="#">
												<img src={twitter} alt="" />
											</Link>
										</li>
										<li>
											<Link to="#">
												<img src={facebook} alt="" />
											</Link>
										</li>
										<li>
											<Link to="#">
												<img src={instagram} alt="" />
											</Link>
										</li>
										<li>
											<Link to="#">
												<img src={github} alt="" />
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-lg-2 offset-lg-1 col-md-4 col-sm-4">
							<div className="fugu--footer-menu">
								<span>Marketplace</span>
								<ul>
									<li>
										<Link to="#">Create A Store </Link>
									</li>
									<li>
										<Link to="#">Start Selling </Link>
									</li>
									<li>
										<Link to="#">My Account </Link>
									</li>
									<li>
										<Link to="#">Job </Link>
									</li>
									<li>
										<Link to="#">List a Item </Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-2 offset-lg-1 col-md-4 col-sm-4">
							<div className="fugu--footer-menu">
								<span>Marketplace</span>
								<ul>
									<li>
										<Link to="#">Art </Link>
									</li>
									<li>
										<Link to="#">Digital Art </Link>
									</li>
									<li>
										<Link to="#">Photography </Link>
									</li>
									<li>
										<Link to="#">Games </Link>
									</li>
									<li>
										<Link to="#">Music </Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-2 offset-lg-1 col-md-4 col-sm-4">
							<div className="fugu--footer-menu">
								<span>Marketplace</span>
								<ul>
									<li>
										<Link to="#">Explore NFTs </Link>
									</li>
									<li>
										<Link to="#">Platform Status </Link>
									</li>
									<li>
										<Link to="#">Help center </Link>
									</li>
									<li>
										<Link to="#">Partners </Link>
									</li>
									<li>
										<Link to="#">Marketplace </Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="fugu--footer-bottom">
					assets <p>&copy; Copyright 2022, All Rights Reserved by Mthemeus</p>
					<div className="fugu--footer-menu">
						<ul>
							<li>
								<Link to="#">Terms </Link>
							</li>
							<li>
								<Link to="#"> Privacy Policy </Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</footer>
	);
}
